import React, {FC} from "react";
import { useTranslation } from "next-i18next";

interface DiveNumberProps {
  numberOfDives: string;
}

export const DiveNumber:FC<DiveNumberProps> = ({numberOfDives}) => {

  const { t } = useTranslation();


  return (
    <div style={{fontWeight: 500,
      display: "block",
      padding: "2px 6px",
      textAlign: "center"}}>
      {!!numberOfDives &&
        (numberOfDives.indexOf("<") >= 0
          ? t("less-than-dives", { dives: 50 })
          : t("more-than-dives", {
              dives: (numberOfDives + "").replace("+", "")
            }))}
      {!numberOfDives && t('unknown-number-of-dives')}
    </div>
  );
}
